import { GetCategoryConfigCategoriesQuery } from 'src/graphql/generated';
import { SpeakUpReportedFieldsValue } from '../types';

type Category = NonNullable<
  GetCategoryConfigCategoriesQuery['getOrganisationCategories']
>[number];

const DEFAULT_LOCALE = 'en-GB';

export interface EditCategoryState {
  name: string;
  description: string;
  isDetermined: boolean;
  isReported: boolean;
  reportedFields: SpeakUpReportedFieldsValue;
}

const resolveName = (category: Category): string => {
  const locales = category.locales as
    | Record<string, { name?: string } | undefined>
    | undefined;
  if (!locales) return '';
  return (
    locales[DEFAULT_LOCALE]?.name ??
    Object.values(locales).find((l) => l?.name)?.name ??
    ''
  );
};

const resolveDescription = (category: Category): string => {
  const locales = category.locales as
    | Record<string, { description?: string } | undefined>
    | undefined;
  return locales?.[DEFAULT_LOCALE]?.description ?? '';
};

export const mapCategoryToEditState = (
  category: Category,
): EditCategoryState => ({
  name: resolveName(category),
  description: resolveDescription(category),
  isDetermined: category.isDeterminedCategory,
  isReported: category.isReportedCategory,
  reportedFields: {
    questionFlow: category.isCustomQuestions ? 'custom' : 'default',
    reportType: category.question ? 'inquiry' : 'misconduct',
    channels: {
      vaultTalk: category.displayInVaultTalk,
      slack: category.displayInCollaborationToolIntegration,
      reportingPortal: category.displayInOpenReporting,
    },
    goTogether: category.allowGoTogether,
    manualIntake: category.displayInManualIntake,
  },
});
